export class ForcedExternalLogoutFlag {
  static is() : boolean {
    return sessionStorage.getItem("forcedExternalLogout") === "1";
  }
  static set() {
    sessionStorage.setItem("forcedExternalLogout", "1");
  }

  static remove() {
    sessionStorage.removeItem("forcedExternalLogout");
  }
}
